var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	37381: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))))),
	13855: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e(3144).then(() => (() => (__webpack_require__(43144))))))),
	9303: () => (loadStrictVersion("default", "windows-iana", false, [1,5,1,0], () => (__webpack_require__.e(8378).then(() => (() => (__webpack_require__(78378))))))),
	21302: () => (loadSingletonVersion("default", "moment", false, [1,2,30,1], () => (Promise.all([__webpack_require__.e(8666), __webpack_require__.e(6857)]).then(() => (() => (__webpack_require__(99420))))))),
	35002: () => (loadSingletonVersion("default", "styled-components", false, [1,5,3,11], () => (__webpack_require__.e(4301).then(() => (() => (__webpack_require__(64301))))))),
	46389: () => (loadSingletonVersion("default", "react-device-detect", false, [1,2,2,3], () => (__webpack_require__.e(7056).then(() => (() => (__webpack_require__(47056))))))),
	87623: () => (loadSingletonVersion("default", "react-i18next", false, [1,13,5,0], () => (__webpack_require__.e(7806).then(() => (() => (__webpack_require__(87806))))))),
	2082: () => (loadSingletonVersion("default", "react-content-loader", false, [1,5,1,4], () => (__webpack_require__.e(5885).then(() => (() => (__webpack_require__(15885))))))),
	15704: () => (loadSingletonVersion("default", "axios", false, [2,0,22,0], () => (__webpack_require__.e(6660).then(() => (() => (__webpack_require__(26660))))))),
	58891: () => (loadSingletonVersion("default", "i18next", false, [1,20,6,1], () => (__webpack_require__.e(2051).then(() => (() => (__webpack_require__(22051))))))),
	39894: () => (loadSingletonVersion("default", "react-window", false, [1,1,8,10], () => (__webpack_require__.e(9111).then(() => (() => (__webpack_require__(9111))))))),
	57313: () => (loadSingletonVersion("default", "react-toastify", false, [1,10,0,6], () => (__webpack_require__.e(9028).then(() => (() => (__webpack_require__(49028))))))),
	3803: () => (loadSingletonVersion("default", "mobx", false, [1,6,13,3], () => (__webpack_require__.e(3794).then(() => (() => (__webpack_require__(83794))))))),
	59666: () => (loadSingletonVersion("default", "react-tooltip", false, [1,5,28,0], () => (__webpack_require__.e(9090).then(() => (() => (__webpack_require__(79090))))))),
	82579: () => (loadSingletonVersion("default", "prop-types", false, [1,15,8,1], () => (__webpack_require__.e(9067).then(() => (() => (__webpack_require__(39067))))))),
	47399: () => (loadStrictVersion("default", "copy-to-clipboard", false, [1,3,3,3], () => (__webpack_require__.e(200).then(() => (() => (__webpack_require__(40200))))))),
	30725: () => (loadStrictVersion("default", "queue-promise", false, [4,2,2,1], () => (__webpack_require__.e(7742).then(() => (() => (__webpack_require__(67742))))))),
	4304: () => (loadStrictVersion("default", "react-markdown", false, [1,9,0,1], () => (Promise.all([__webpack_require__.e(6000), __webpack_require__.e(2754)]).then(() => (() => (__webpack_require__(82754))))))),
	6980: () => (loadStrictVersion("default", "react-smartbanner", false, [1,5,1,4], () => (__webpack_require__.e(247).then(() => (() => (__webpack_require__(10247))))))),
	70332: () => (loadSingletonVersion("default", "react-autosize-textarea", false, [1,7,1,0], () => (__webpack_require__.e(1215).then(() => (() => (__webpack_require__(51215))))))),
	80380: () => (loadStrictVersion("default", "remark-gfm", false, [1,4,0,0], () => (Promise.all([__webpack_require__.e(6000), __webpack_require__.e(8556)]).then(() => (() => (__webpack_require__(8556))))))),
	2392: () => (loadSingletonVersion("default", "react-router-dom", false, [1,6,27,0], () => (Promise.all([__webpack_require__.e(1613), __webpack_require__.e(2371)]).then(() => (() => (__webpack_require__(82371))))))),
	6803: () => (loadSingletonVersion("default", "sjcl", false, [1,1,0,8], () => (Promise.all([__webpack_require__.e(6580), __webpack_require__.e(9165)]).then(() => (() => (__webpack_require__(56580))))))),
	17242: () => (loadStrictVersion("default", "crypto-js", false, [1,4,2,0], () => (__webpack_require__.e(8705).then(() => (() => (__webpack_require__(88705))))))),
	18716: () => (loadSingletonVersion("default", "mobx-react", false, [1,7,6,0], () => (Promise.all([__webpack_require__.e(2980), __webpack_require__.e(3855), __webpack_require__.e(3803)]).then(() => (() => (__webpack_require__(22980))))))),
	34579: () => (loadStrictVersion("default", "hex-rgb", false, [1,5,0,0], () => (__webpack_require__.e(3889).then(() => (() => (__webpack_require__(73889))))))),
	51587: () => (loadSingletonVersion("default", "email-addresses", false, [1,3,1,0], () => (__webpack_require__.e(8070).then(() => (() => (__webpack_require__(28070))))))),
	60723: () => (loadSingletonVersion("default", "resize-image", false, [2,0,1,0], () => (__webpack_require__.e(8902).then(() => (() => (__webpack_require__(48902))))))),
	74141: () => (loadSingletonVersion("default", "react-svg", false, [1,16,1,34], () => (__webpack_require__.e(3567).then(() => (() => (__webpack_require__(5948))))))),
	76425: () => (loadStrictVersion("default", "file-saver", false, [1,2,0,5], () => (__webpack_require__.e(5060).then(() => (() => (__webpack_require__(45060))))))),
	83582: () => (loadSingletonVersion("default", "query-string", false, [4,7,1,3], () => (__webpack_require__.e(8032).then(() => (() => (__webpack_require__(68032))))))),
	60579: () => (loadSingletonVersion("default", "react-text-mask", false, [1,5,5,0], () => (__webpack_require__.e(2943).then(() => (() => (__webpack_require__(72943))))))),
	78110: () => (loadSingletonVersion("default", "react-dropzone", false, [1,11,7,1], () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(30987))))))),
	23806: () => (loadSingletonVersion("default", "react-window-infinite-loader", false, [1,1,0,9], () => (__webpack_require__.e(7415).then(() => (() => (__webpack_require__(27415))))))),
	41678: () => (loadSingletonVersion("default", "react-virtualized-auto-sizer", false, [1,1,0,24], () => (__webpack_require__.e(9686).then(() => (() => (__webpack_require__(19686))))))),
	10994: () => (loadStrictVersion("default", "react-colorful", false, [1,5,6,1], () => (__webpack_require__.e(7666).then(() => (() => (__webpack_require__(87666))))))),
	14611: () => (loadStrictVersion("default", "react-avatar-editor", false, [1,13,0,2], () => (__webpack_require__.e(1866).then(() => (() => (__webpack_require__(91866))))))),
	90523: () => (loadStrictVersion("default", "react-string-format", false, [2,0,1,4], () => (__webpack_require__.e(5759).then(() => (() => (__webpack_require__(25759))))))),
	26386: () => (loadStrictVersion("default", "element-resize-detector", false, [1,1,2,4], () => (__webpack_require__.e(2087).then(() => (() => (__webpack_require__(82087))))))),
	17624: () => (loadStrictVersion("default", "@codemirror/lang-javascript", false, [1,6,2,2], () => (Promise.all([__webpack_require__.e(6776), __webpack_require__.e(8482), __webpack_require__.e(1339)]).then(() => (() => (__webpack_require__(31339))))))),
	43072: () => (loadStrictVersion("default", "@uiw/react-codemirror", false, [1,4,23,5], () => (Promise.all([__webpack_require__.e(6776), __webpack_require__.e(8482), __webpack_require__.e(977)]).then(() => (() => (__webpack_require__(70977))))))),
	45286: () => (loadStrictVersion("default", "@uiw/codemirror-theme-github", false, [1,4,23,5], () => (Promise.all([__webpack_require__.e(6776), __webpack_require__.e(7756)]).then(() => (() => (__webpack_require__(45375))))))),
	72782: () => (loadStrictVersion("default", "@onlyoffice/docspace-sdk-js", false, [1,1,1,0], () => (__webpack_require__.e(8752).then(() => (() => (__webpack_require__(98752))))))),
	47111: () => (loadStrictVersion("default", "react-hotkeys-hook", false, [1,3,4,7], () => (__webpack_require__.e(1915).then(() => (() => (__webpack_require__(31915))))))),
	47925: () => (loadStrictVersion("default", "ts-pattern", false, [1,5,5,0], () => (__webpack_require__.e(9269).then(() => (() => (__webpack_require__(29269)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"258": [
		9303,
		21302,
		35002,
		46389
	],
	"579": [
		60579
	],
	"994": [
		10994
	],
	"1678": [
		41678
	],
	"1881": [
		2392,
		6803,
		17242,
		18716,
		34579,
		51587,
		60723,
		74141,
		76425,
		83582
	],
	"3474": [
		2082
	],
	"3803": [
		3803
	],
	"3855": [
		13855
	],
	"4066": [
		47925
	],
	"4915": [
		39894
	],
	"4960": [
		82579
	],
	"5687": [
		4304,
		6980,
		70332,
		80380
	],
	"5704": [
		15704
	],
	"5786": [
		26386
	],
	"6406": [
		30725
	],
	"6992": [
		90523
	],
	"7111": [
		47111
	],
	"7381": [
		37381
	],
	"7399": [
		47399
	],
	"7623": [
		87623
	],
	"8110": [
		78110
	],
	"8457": [
		58891
	],
	"8481": [
		17624,
		43072,
		45286,
		72782
	],
	"8830": [
		23806
	],
	"9519": [
		14611
	],
	"9666": [
		59666
	],
	"9721": [
		57313
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}